import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PropertiesSettings } from 'src/app/core/configuration/properties-settings';
import { HelpersService } from '../../core/services/helpers.service';
import { OperationsService } from '../../core/services/operations.service';
import { EsitoAdapter } from '../components/fascicolo/esiti-update/esito-adapter';
import { Classificazione } from '../models/classificazione';
import { Controparte } from '../models/controparte';
import { Esito } from '../models/esito';
import { EsitoPerSocieta } from '../models/esito-per-societa';
import { FascicoloFull } from '../models/fascicolo/fascicolo-full';
import { SoggettoPratica } from '../models/tipologiche/soggetto-pratica';
import { TipoEsito } from '../models/tipologiche/tipo-esito';
import { FormValidationService } from '../services/form-validation.service';
import { BaseForm } from './base-Form';
import { AltraParte } from '../models/altraparte';
import { LegaleIncaricato } from '../models/legale-incaricato';

export abstract class EsitiDatiGeneraliForm extends BaseForm {
  aggiornaForm: FormGroup;
  public request: Esito;
  fascicolo: FascicoloFull;
  // protected urlReadPratica: string;
  // protected urlReadSezioneClassificazione: string;
  tipoEsitiOptions: TipoEsito[] = [];
  esitiPerSocietaOptions: EsitoPerSocieta[] = [];
  societaOptions: SoggettoPratica[]=[];
  classificazioniOptions: Classificazione[]=[];
  contropartiOptions: Controparte[]=[];
  altrePartiOptions: AltraParte[]=[];
  legaliOptions: LegaleIncaricato[]=[];
  PROPERTIES_SETTINGS = PropertiesSettings;


  msgNoControparti: string;
  msgNoClassificazioni: string;

  constructor(private helpers: HelpersService, protected operations: OperationsService, private campiForm: FormBuilder,
          private formValidationService: FormValidationService) {
            super();
  }

  createForm() {
    this.request = new EsitoAdapter(this.getEsito()).esito;
    this.aggiornaForm = this.campiForm.group({
      tipoEsito: [this.request.tipoEsito, Validators.required],
      esitoPerSocieta: [this.request.esitoPerSocieta, Validators.required],
      dataDeposito: [this.request.dataDeposito],
      //societa: [this.request.societa, Validators.required],
      numeroEsito: [this.request.numeroEsito, Validators.required],
      annoEsito: [
        this.request.annoEsito, 
        Validators.compose([
          Validators.required, 
          this.formValidationService.anno
        ])
      ],
      definitivo: [this.request.definitivo],
      dataPubblicazione: [this.request.dataPubblicazione,(this.fascicolo.praticaBase.tipoPratica.descrizione!='PENALE')? Validators.required : null],
      dataNotifica: [this.request.dataNotifica],
      dataImpugnazione: [this.request.dataImpugnazione],
      note: [this.request.note],
      numeroProtocollo: [this.request.numeroProtocollo],
      dataComunicazione: [this.request.dataComunicazione],
      dataTrasmissioneSentenza:[this.request.dataTrasmissioneSentenza],
      dataPronuncia:[this.request.dataPronuncia],
      flagCondannaInSolido:[this.request.flagCondannaInSolido],
      flagRivalsa:[this.request.flagRivalsa],
      dataIrrevocabilita: [this.request.dataIrrevocabilita]
    });
  }

  populateSelect() {
    if (this.tipoEsitiOptions.length === 0) {
      this.helpers.getTipiEsiti().subscribe(response => {
        this.tipoEsitiOptions = response.filter(el => el.label.toUpperCase() != 'DELIBERAZIONE CDA' && el.label.toUpperCase() != 'DELIBERAZIONE UFFICIO')
      });
    }
    if (this.esitiPerSocietaOptions.length === 0) {
      this.helpers.getEsitiPerSocieta().subscribe(response => {
        this.esitiPerSocietaOptions = response;
      });
    }
    if(this.societaOptions.length === 0){
      const tipoPratica = this.fascicolo.praticaBase.tipoPratica.endpoint;
      this.helpers.getSoggetti().subscribe(response => {
        if (PropertiesSettings.PRATICHE_CON.includes(tipoPratica)) {
          this.societaOptions = response.filter(el => el.sigla !== 'CD');
        } else if (PropertiesSettings.PRATICHE_CD.includes(tipoPratica)) {
          this.societaOptions = response.filter(el => el.sigla !== 'CON');
        } else {
          this.societaOptions = response;
        }
      });
        // response => this.societaOptions = response); //.filter(element=>this.isSoggettoInClassificazioni(element)));
     // this.helpers.getSoggettiByIdPratica(this.fascicolo.praticaBase.id).subscribe(response=>this.societaOptions=response);
    }
  }

  update() {
    this.getRequest(this.request);
  }

  abstract getEsito(): Esito;
  abstract getRequest(request: Esito);
}
